// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { trim } from 'lodash-es';

@Injectable()
export class LMUniqueIdService {

  private idIndex = 0;
  private idPrefix = 'lm-id-';
  private ids = [];
  private uniqueWebId = '';

  // DO NOT add other LM services due to the possibility of circular references
  constructor() {}

  // it is up to the caller to determine what information is required to create a unique id
  // array items are set in the order to appear in the id
  // null, undefined, or empty string items are not included in the final id
  // safety: if all items resolve to an empty string, return lm-id
  public uniqueId(items: Array<string>): string {
    const id = items && items.filter( item => {
      if (item && trim(item).length > 0) {
        return true;
      }
    }).join('_');

    return (id && id.length > 0) ? id : (this.idPrefix + this.idIndex++);
  }

  public uniqueAutomationId(items: Array<string>): string {
    const id = items && items.filter( item => {
      if (item && trim(item).length > 0) {
        return true;
      }
    }).join('-');

    return (id && id.length > 0) ? id : (this.idPrefix + this.idIndex++);
  }

  public getUniqueId(): string {
    const id = Math.round(Math.random() * 99999 | 0).toString();

    if (this.ids.includes(id)) {
      this.getUniqueId();
    }

    this.ids.push(id);
    return id;
  }

  public getCompWebUniqueId(): string {
    const lmWebId =  this.getWebUniqueId();
    const screenId = this.getScreenWebUniqueId();
    return `${lmWebId}-${screenId}`;
  }

  private getScreenWebUniqueId(): string {
    return  String(Date.now());
  }

  private getWebUniqueId(): string {
    if (this.uniqueWebId?.length <= 0) {
      this.uniqueWebId = LMUniqueIdService.generateUUID();
    }
    return this.uniqueWebId;
  }

  public static generateUUID(): string {
    const uuid= 'xxxxxxxxxxxx4xxxyx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
         return v.toString(16);
      });
      return uuid;
    }
}
